export function NotFound() {
  return <p className="m-3">404: Page Not Found</p>;
}
